import ApiClient from "./ApiClient"
import SyncResult from "../types/SyncResult"

export const KeyTimeLimitApi = {
    apiPath: 'key-time-limits',

    syncAllByLockingSystemId: async (lockingSystemId: number): Promise<SyncResult> => {
        const params = new URLSearchParams([['lockingSystemId', lockingSystemId.toString()]])

        const result = await ApiClient.get(
            KeyTimeLimitApi.apiPath + '/sync/all', { params }
        )

        return result?.data
    },
}

export default KeyTimeLimitApi